import React from 'react';
import Layout from 'components/layout';
import Contact from 'components/contact';
import cn from 'classnames';
import style from './index.module.scss';
import { WrapperBanner } from 'components/product/banner';
import NewProFeatures from 'components/newProFeatures';
import TabPanel from 'components/product/tabPanel';
import { IMG_PREFIX, features, tabList, tabList2 } from '../../constants/new_product_2024';
import Transition from 'components/transition';

const newProduct2024 = () => {
  return (
    <Layout>
      <div className={style.container}>
        {/* 头图 */}
        {/* <WrapperBanner
          bannerInfo={{
            pcUrl: IMG_PREFIX + 'PC/detailBanner.jpg',
            mUrl: IMG_PREFIX + 'M/detailBanner.jpg',
            classNames: style.headerBanner,
          }}
        >
          <Contact className={style.contact} />
        </WrapperBanner> */}
        {/* 小鱼易连视频会议全景图 */}
        <WrapperBanner
          bannerInfo={{
            pcUrl: IMG_PREFIX + 'PC/all.jpg',
            mUrl: IMG_PREFIX + 'M/all.jpg',
            classNames: style.allSceneBanner,
          }}
        >
          <Transition delay={0.5}>
            <div className={style.title}>小鱼易连视频会议全景图</div>
          </Transition>
          <Transition delay={0.8}>
            <div className={cn(style.desc, style['for-pc'])}>
              <p>小鱼易连应用户所需，从云到端、从底座到应用、从传统到新兴，打造可深入任意业务场景的国产化</p>
              <p>云视频产品方案，为大型组织企业构建开启视频会议的便捷入口，带来智能化的沟通和协作体验</p>
            </div>
            <p className={cn(style.desc, style['for-mobile'])}>
              小鱼易连应用户所需，从云到端、从底座到应用、从传统到新兴，打造可深入任意业务场景的国产化云视频产品方案，为大型组织企业构建开启视频会议的便捷入口，带来智能化的沟通和协作体验
            </p>
          </Transition>
        </WrapperBanner>
        {/* 全能型云视频平台 */}
        <div className={style.platform}>
          <Transition delay={0.5}>
            <div className={style.title}>全能型云视频平台</div>
            <div className={style.desc}>无所不融的视频能力中台，提供国产化高安全数字化底座</div>
          </Transition>
          <Transition delay={0.8}>
            <div className={style.content}>
              {new Array(4).fill('').map((item: any, index: number) => {
                return <img className={style.item} key={index} src={`${IMG_PREFIX}desk-icon${index}.jpg`} alt="" />;
              })}
            </div>
          </Transition>
        </div>
        {/* 第二代双引擎硬件MCU */}
        <NewProFeatures
          pcUrl="PC/mcu.jpg"
          mUrl="M/mcu.png"
          features={features.MCU}
          IMG_PREFIX={IMG_PREFIX}
          title="第二代双引擎硬件MCU"
          desc="国产硬件MCU之光，一端畅享大规模、无限级联的视频会议"
          type="MCU"
          rightImg="AMS1000.png"
        />
        {/*  双模双栈终端架构 */}
        <NewProFeatures
          pcUrl="PC/doubleMode.jpg"
          mUrl="M/doubleMode.jpg"
          features={features.doubleMode}
          IMG_PREFIX={IMG_PREFIX}
          title="双模双栈终端架构"
          desc="任意场景极简开启视频会议，方寸之间畅享沉浸式沟通协作"
          type="doubleMode"
        />
        {/* 融合会管平台 */}
        <div className={style.tabWrapper}>
          <TabPanel list={tabList} title={'融合会管平台'} titleDesc={'原厂自研的统一会管新模式，让视频会议召开无忧、管理高效'} className={style.platforms} />
        </div>
        {/* 保密视频会议 */}
        <NewProFeatures pcUrl="PC/secret.jpg" mUrl="M/secret.jpg" features={features.secret} IMG_PREFIX={IMG_PREFIX} title="保密视频会议" desc="自主可控安全合规，坚如磐石的高品质会议" type="secret" />
        {/* 集大成开发平台 */}
        <div className={cn(style.tabWrapper, style.devPlatWrapper)}>
          <TabPanel list={tabList2} title={'集大成开发平台'} titleDesc="化繁为简，为全行业提供高品质的互动音视频服务 " className={cn(style.platforms, style.devPlatform)} />
        </div>
        {/* AI视频会议 */}
        <NewProFeatures pcUrl="PC/ai.jpg" mUrl="M/ai.jpg" features={features.AI} IMG_PREFIX={IMG_PREFIX} title="AI视频会议" desc="智能化飞跃，开启视频会议新未来" type="AI" />
        {/* 底部banner */}
        <WrapperBanner
          bannerInfo={{
            pcUrl: IMG_PREFIX + 'PC/lastBanner.jpg',
            mUrl: IMG_PREFIX + 'M/lastBanner.jpg',
            classNames: `${style.headerBanner} ${style.footerBanner}`,
          }}
        >
          <Transition delay={0.5}>
            <div className={style.title}>
              <p>在未来的数字世界里</p>
              <p>每一次连接，都不应该被阻隔</p>
            </div>
          </Transition>
          <Transition delay={0.8}>
            <Contact className={style.contact} />
          </Transition>
        </WrapperBanner>
      </div>
    </Layout>
  );
};

export default newProduct2024;
